import * as React from 'react';
import { withStyles } from '@material-ui/core/styles';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { getTranslate } from 'react-localize-redux';

import {
    IconButton, Menu, MenuItem, Typography, Button, ListItemIcon, ListItemText,
} from '@material-ui/core';
import {
    CollapseIcon,
    ExpandIcon,
} from '../icons';
import VimoModal from './VimoModal';

const styles = theme => ({
    menu: {
        maxWidth: 500,
    },
    modalActions: {
        marginTop: theme.spacing(6),
        display: 'flex',
        justifyContent: 'center',
    },
    dangerItem: {
        color: theme.palette.error.main,
    },
    dangerButton: {
        color: theme.palette.error.main,
    },
});


class YouwellMenu extends React.Component {
    state = {
        menuAnchorEl: null,
        selectedItemIndex: null,
    };

    handleMenuClick = (event) => {
        this.setState({ menuAnchorEl: event.currentTarget });
    };

    handleMenuClose = () => {
        this.setState({ menuAnchorEl: null });
    };

    openModal = selectedItemIndex => () => {
        const filteredItems = this.props.menuItems.filter(d => !d.hidden);
        const modal = filteredItems[selectedItemIndex];
        if (modal.clickAction) {
            this.setState({ menuAnchorEl: null });
            modal.clickAction();
        } else {
            this.setState({ menuAnchorEl: null, selectedItemIndex });
        }
    }

    setupOnBeforeClose = (onBeforeClose) => {
        this.onBeforeClose = onBeforeClose;
    }

    closeModal = () => {
        if (this.onBeforeClose && !this.onBeforeClose()) {
            this.setState({ showUnsavedMessage: true });
        } else {
            this.setState({ showUnsavedMessage: false, selectedItemIndex: null });
        }
    }

    onClickAction = modal => () => {
        if (modal.action) {
            modal.action(this.closeModal);
        }
    }

    render() {
        const {
            classes, className, menuItems,
        } = this.props;
        const { menuAnchorEl, selectedItemIndex, showUnsavedMessage } = this.state;

        const filteredItems = menuItems ? menuItems.filter(d => !d.hidden) : [];
        if (filteredItems.length === 0) {
            return null;
        }

        const modal = selectedItemIndex !== null && filteredItems[selectedItemIndex];

        return (
            <React.Fragment>
                <IconButton
                    aria-owns={menuAnchorEl ? 'simple-menu' : undefined}
                    aria-haspopup="true"
                    onClick={this.handleMenuClick}
                    className={className}
                >
                    {this.state.menuAnchorEl ? <CollapseIcon color="primary" /> : <ExpandIcon color="primary" />}
                </IconButton>
                <Menu
                    id="simple-menu"
                    anchorEl={menuAnchorEl}
                    open={Boolean(menuAnchorEl)}
                    onClose={this.handleMenuClose}
                    className={classes.menu}
                    anchorOrigin={{
                        vertical: 'bottom',
                        horizontal: 'right',
                    }}
                    transformOrigin={{
                        vertical: 'top',
                        horizontal: 'right',
                    }}
                    getContentAnchorEl={null}
                >
                    {filteredItems.map((item, index) => (
                        <MenuItem key={item.header} onClick={this.openModal(index)}>
                            {item.Icon && (
                                <ListItemIcon className={item.danger ? classes.dangerItem : null}>
                                    <item.Icon />
                                </ListItemIcon>
                            )}
                            <ListItemText inset={!item.Icon} primary={item.menuItemText || item.header} classes={{ primary: item.danger ? classes.dangerItem : null }} />
                        </MenuItem>
                    ))}
                </Menu>

                <VimoModal
                    open={!!modal}
                    onClose={this.closeModal}
                    heading={modal && modal.header}
                    showUnsavedMessage={showUnsavedMessage}
                    {...(modal ? modal.ModalProps : {})}
                >
                    {modal && (
                        <>
                            {modal.Element ? (
                                <modal.Element
                                    onBeforeClose={this.setupOnBeforeClose}
                                    onClose={this.closeModal}
                                    {...modal.ElementProps}
                                />
                            ) : (
                                <>
                                    <Typography color="textSecondary">
                                        {modal.description}
                                    </Typography>

                                    <div className={classes.modalActions}>
                                        <Button onClick={this.onClickAction(modal)} color="primary" variant="outlined" className={modal.danger ? classes.dangerButton : null}>
                                            {modal.actionText || modal.header}
                                        </Button>
                                    </div>
                                </>
                            )}
                        </>
                    )}
                </VimoModal>
            </React.Fragment>
        );
    }
}

YouwellMenu.propTypes = {
    classes: PropTypes.object.isRequired,
    menuItems: PropTypes.PropTypes.arrayOf(
        PropTypes.shape({
            header: PropTypes.string.isRequired,
            Element: PropTypes.oneOfType([
                PropTypes.func,
                PropTypes.object,
            ]),
            ElementProps: PropTypes.object,
            ModalProps: PropTypes.object,
            description: PropTypes.string,
            action: PropTypes.func,
            actionText: PropTypes.string,
            clickAction: PropTypes.func,
        }),
    ).isRequired,
    className: PropTypes.string,
};

YouwellMenu.defaultProps = {
    className: null,
};

const mapStateToProps = state => ({
    translate: getTranslate(state.localize),
    clientConfig: state.auth.clientConfig,
});

export default connect(mapStateToProps)(withStyles(styles)(YouwellMenu));
